import {ISVG} from "../../common/Logo/Logo";

export interface IShape1Props extends Pick<ISVG, "fill"> {}

export const Shape5 = ({ fill }: IShape1Props) => {
    const _fill = fill ?? "white;";

    return (
        <svg
            width="232"
            height="113"
            viewBox="0 0 232 113"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M244.676 8.47527C287.646 24.3272 296.708 84.6597 333.834 111.481C360.653 130.855 398.287 125.781 427.787 140.76C461.16 157.705 525.653 168.515 518.53 205.26C507.227 263.567 378.828 269.991 391.488 328.019C406.255 395.704 604.3 374.488 568.374 433.722C528.35 499.713 413.676 391.353 339.71 413.389C311.524 421.786 353.665 473.299 343.233 500.796C333.542 526.339 312.235 554.984 285.032 557.505C256.572 560.143 240.399 506.014 212.659 512.899C159.14 526.182 120.86 644.906 79.4086 608.539C33.9336 568.642 104.729 491.656 122.554 433.845C129.815 410.295 171.679 384.386 153.728 367.5C114.361 330.468 9.56707 372.267 0.459458 318.993C-7.64192 271.604 93.4608 299.969 140.43 289.714C156.159 286.28 187.856 294.354 186.933 278.281C182.092 193.998 108.118 117.282 125.786 34.7299C134.352 -5.29724 206.273 -5.69214 244.676 8.47527Z"
                fill={_fill}
            />
        </svg>
    );
};
